import { Authentication } from '../../common/auth/Authentication';
import { ApiServer } from '../server/ApiServer';
import { AccountServer } from '../../common/account/AccountServer';
import { AuthServerApiBase, TromanWebApiBase, ValmanWebApiBase } from "config";

angular.module('tromanWeb').provider('authenticationService', [function authenticationServiceProvider() {

    var provider = this;
    this.unauthorized = null;

    this.$get = ['$q', '$injector', '$log', '$rootScope', function TromanServerFactory($q, $injector, $log, $rootScope) {

        function loginNeededCallback() {
            // Auth "should" always run outside of $apply, so async might not be necessary.
            $rootScope.$applyAsync(() => {
                try {
                    if (provider.unauthorized != null) {
                        $injector.invoke(provider.unauthorized, null);
                    }
                } catch (exc) {
                    $log.debug(exc);
                }
            });
        }

        return new Authentication(AuthServerApiBase, $q.when, loginNeededCallback);
    }];
}]);

angular.module('tromanWeb').factory('tromanServer', ['authenticationService', 'isTroman', function tromanServerFactory(authenticationService, isTroman) {
    var urlbase = isTroman ? TromanWebApiBase : ValmanWebApiBase;
    return new ApiServer(authenticationService, urlbase);
}]);


angular.module('tromanWeb').factory('accountServer', ['authenticationService', function accountServerFactory(authenticationService) {
    return new AccountServer(authenticationService);
}]);
